import { isEqual } from 'lodash'

import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'RulesGeneratorButton',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    watchValueHandler() {
      const nextValue = this._inputFilter(this.value)
      if (isEqual(this.proxy, nextValue)) {
        return
      }

      this.receiveValue()
    }
  },

  render
}
